<div
  tabindex="0"
  class="outline-none cursor-pointer focus-visible:ring-2 focus-visible:ring-midnight/20 px-5 py-3 hover:bg-[#E5EBE5]"
  [class.pointer-events-none]="disabled()"
  [class.opacity-50]="disabled()"
  (click)="onClick()"
>
  <ng-content />
</div>
